<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ResourceForm from './ResourceForm.vue';

defineProps({
  resource: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();
const dialogRef = ref(null);

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('ARROWS_AI.RESOURCES.EDIT_TITLE')"
    :description="t('ARROWS_AI.RESOURCES.EDIT_DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="emit('close')"
  >
    <ResourceForm
      :resource="resource"
      :submit-label="t('ARROWS_AI.UPDATE')"
      @submit="emit('submit', $event)"
      @cancel="dialogRef.close()"
    />
    <template #footer />
  </Dialog>
</template>
